module.exports = __webpack_public_path__ + "img/no-monthly-team-rating.2cc7eca7.webp";